// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Network = function Network(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 1.4a5.2 5.2 0 00-5.049 6.44A10.039 10.039 0 004.1 10.03 31.4 31.4 0 008 14.6a31.336 31.336 0 003.9-4.575 10.008 10.008 0 001.147-2.194A5.2 5.2 0 008 1.4zm0 3a2.27 2.27 0 11-2.27 2.27A2.251 2.251 0 018 4.391z"
    }))
  );
};

export default Network;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Network.js
// module id = 1033
// module chunks = 0